import * as React from 'react';
import { flow, each, get } from 'lodash';
import {Field, formValueSelector} from 'redux-form';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { actions as quoteActions } from '../../../../../../services/quote/reducer';
import SelectControl from '../../../../../../components/SelectControl';
import {isRequired} from '../../../../../../util/validators';
import {Col, ControlLabel, FormGroup, Row} from 'react-bootstrap';
import FaTrash from 'react-icons/fa/trash';

interface ISpecifiedDriverProps {
  index: number;
  name: string;
  fields: any;
  driverOptions: any[];
}

class SpecifiedDriver extends React.Component<ISpecifiedDriverProps> {
  public deleteDriver = (index) => (e) => {
    const { fields } = this.props;

    fields.remove(index);
  }

  public render() {
    const { name, index, fields, driverOptions } = this.props;

    return (
      <Row className="margin-bottom">
        <Col sm={4} componentClass={ControlLabel}>
          {'Driver ' + (index + 1)}
        </Col>
        <Col sm={7}>
          <Field
            name={name + '.driver'}
            component={SelectControl}
            validate={[ isRequired ]}
            options={driverOptions}
            placeholder="Please Select"
          />
        </Col>
        <Col sm={1}>
          <div
            className="trash-btn"
            onClick={this.deleteDriver(index)}
          >
            <FaTrash />
          </div>
        </Col>
      </Row>
    );
  }
}

export default flow([
  (component) => {
    return component;
  },
  connect(
    (state: IStore) => {
      return {
        quote: state.quote,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({...quoteActions}, dispatch),
      },
    }),
  ),
])(SpecifiedDriver);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Vehicles/components/SpecifiedDriver/index.tsx